import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { AlertAction, AuthAction } from '../../actions';
import RLib from "../../components/common/RLib"
import { Translate as t } from '../../config/Translate';

const AdminUserEditUpdatePassword = ({ adminid, user, GetUser, ResultSuccess, ResultError }) => {

	const [isLoading, setIsLoading] = useState(true);
	const [errMsg, setErrMsg] = useState("");
	const [errMsgforCheck, setErrMsgforCheck] = useState("");
	const [newpassword, setNewpassword] = useState({
		password: "",
		passwordConfirm: "",
	});

	useEffect(() => {
		setIsLoading(adminid != user.adminid)
	}, [user])

	const handleUpdatePassword = (e) => {
		if (!RLib.ValidatePasswordStrength(newpassword.password)) {
			// BUG-143 ③: 실제 검증 규칙(8자 이상 + 대문자/소문자/숫자 중 2종 조합)에 맞게 문구 정정.
			// (기존 문구는 'symbols 포함'으로 잘못 안내하여 사용자 혼란 유발)
			setErrMsg("Password must be at least 8 characters and include at least two of: uppercase letters, lowercase letters, numbers.");
			return false;
		} else {
			setErrMsg("");
		}
		if (newpassword.password != newpassword.passwordConfirm) {
			setErrMsgforCheck("Check Password Confirm");
			return false;
		} else {
			setErrMsgforCheck("");
		}

		// BUG-143 ②: 라우트는 /user/:adminid 이고 BE 는 adminid 로 사용자를 조회하므로
		// Mongo _id 가 아닌 adminid 를 전달해야 한다(기존 user._id → 사용자 미발견으로 적용 안 됨).
		AuthAction.UpdatePasswordByAdmin(user.adminid, { password: newpassword.password }).then((ret) => {
			setNewpassword({ password: "", passwordConfirm: "", });

			if (ret.status == "success")
				ResultSuccess(t('common.message.success.saved'));
			else
				ResultError("Fail!");
		});
	}

	const handleChangePassword = (e) => {
		const { name, value } = e.target;
		setNewpassword(newpassword => ({ ...newpassword, [name]: value }));
	}

	return (
		<div className="section">
			<div className="card">
				<div className="card-body">
					<div className="form-group basic">
						<label>New Password</label>
						<input type="password" className="form-control" autoComplete="off"
							name="password"
							onChange={(e) => handleChangePassword(e)}
							value={newpassword.password} />
					</div>
					{errMsg && <label className="error">{errMsg}</label>}
					<div className="form-group basic">
						<label>New Password Confirm</label>
						<input type="password" className="form-control" autoComplete="off"
							name="passwordConfirm"
							onChange={(e) => handleChangePassword(e)}
							value={newpassword.passwordConfirm} />
					</div>
					{errMsgforCheck && <label className="error">{errMsgforCheck}</label>}
					<button className="btn btn-primary btn-sm" onClick={handleUpdatePassword}>{t('auth.button.updatePassword')}</button>
				</div>
			</div>
		</div>
	)
}

const mapState = (state) => {
	const user = state.AdminUserReducer.user;
	return { user };
};

const mapDispatch = (dispatch) => ({
	ResultSuccess: (msg) => dispatch(AlertAction.Success(msg)),
	ResultError: (msg) => dispatch(AlertAction.Error(msg)),
});

export default connect(mapState, mapDispatch)(AdminUserEditUpdatePassword);